import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function GeneralQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="General Queries" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  What is the Free-to-Play version of PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    The Free-to-Play version lets you enjoy all the excitement of poker without using real money. You play with free chips, earn Reward Points through gameplay, and redeem them at the Baazi Store for offers and gift cards from top brands.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Can I use my existing PokerBaazi account?
                </div>
                <div className={style.sub_text3}>
                    Yes! You can log in using your existing PokerBaazi account. If you’re new, just sign up for free on the Google Play Store or Apple App Store - no deposit needed.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Can I switch between Free-to-Play and Cash modes?
                </div>
                <div className={style.sub_text3}>
                    No. PokerBaazi now focuses entirely on Free-to-Play - a skill-first, rewards-driven experience where every hand helps you progress.
                </div>
            </div>
        </div>
    )
}


export function LeaderboardAndProgression() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title=" Leaderboards & Progression" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  How do leaderboards work?
                </div>
                <div className={style.sub_text3}>
                    Leaderboards track your performance across quick games and tournaments. Play regularly to earn points, move up ranks, and win bonus Reward Points every week.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  My leaderboard rank isn’t updating.
                </div>
                <div className={style.sub_text3}>
                    Ranks refresh every few minutes. If you don’t see an update, share your username with us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> and we’ll check it for you.
                </div>

            </div>
        </div>
    )
}

export function GameplayQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Gameplay Queries" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  What games can I play?
                </div>
                <div className={style.sub_text3}>
                    You can play Texas Hold’em, Omaha, All-in or Fold, Super Hold’em, and Open Face Poker (OFC) - available across quick games and tournaments.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  I have run out of chips. What should I do?
                </div>
                <div className={style.sub_text3}>
                    You’ll get free chips daily, hourly, and by watching ads. You can also earn more by completing Task Rewards or ranking on leaderboards.
                </div>

            </div>
        </div>
    )
}

export function BaaziStore() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Baazi Store" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.   What is the Baazi Store?
                </div>
                <div className={style.sub_text3}>
                    The Baazi Store is where you redeem your Reward Points for vouchers, offers, and gift cards from top brands - powered by Advantage Club.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   I redeemed a reward but didn’t receive it.
                </div>
                <div className={style.sub_text3}>
                    Redemptions can take up to 48 hours to process. If it still hasn’t arrived, share your selected reward name and redemption date with us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> and we’ll check it right away.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Do I need a separate Advantage Club login?
                </div>
                <div className={style.sub_text3}>
                    No - you’re automatically logged in through PokerBaazi. No extra steps needed. <br />
                    For premium offers and surprise drops, explore the Baazi Select membership.

                </div>


            </div>
        </div>
    )
}
export function BaaziSelectMembership() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Baazi Select Membership" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  What is Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Baazi Select is our premium membership that unlocks advanced in-game features, premium visual customisations, and exclusive access to Poker TV - including upcoming seasons of The Circuit.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   What does Baazi Select include?
                </div>
                <div className={style.sub_text3}>
                    You get premium avatars and themes, gameplay tools like Rabbit and Player Stats, enhanced table setups, full Poker TV access, and a wider range of premium offers in the Rewards Store.                 </div>
                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>
                    Q.   Does Baazi Select give me a gameplay advantage?
                </div>
                <div className={style.sub_text3}>
                    No. Baazi Select enhances your overall experience but does not provide unfair advantages or alter game outcomes.
                </div>



                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>
                    Q.  How do I get Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    You can subscribe from the <strong>Membership</strong> section on the home screen or through your <strong>Profile </strong>settings.
                </div>


                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>
                    Q.  How does Baazi Select work with Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Baazi Select unlocks a premium suite of offers and gift cards from top brands in the Rewards Store. Without membership, your selection is limited.
                </div>


                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>
                    Q.  Can I cancel whenever I want?
                </div>
                <div className={style.sub_text3}>
                    Yes. Your membership remains active until the end of the pack you purchased—no extra steps required.
                </div>


                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>
                    Q.  What more can I look forward to?
                </div>
                <div className={style.sub_text3}>
                    Expect surprise packages in the Baazi Store, along with new premium tools, themes, and exclusive Poker TV content as they roll out.
                </div>


            </div>
        </div>
    )
}

export function TaskRewards() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Task Rewards" />
            <div className="main-container mb-5 px-3"><div className={style.sub_text2_q}> Q. What are Task Rewards?  </div>
                <div className={style.sub_text3}>
                    <p>Task Rewards are daily and weekly challenges that give you chips or Reward Points when completed. They help you progress faster and stay engaged with new goals every day. </p>
                </div>
                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>Q. I didn’t receive my task reward.  </div>
                <div className={style.sub_text3}>
                    <p > Share your task name and completion time with us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> - we’ll make sure it’s credited soon. </p>
                </div>


            </div>
        </div>
    )
}

export function TechnicalQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Technical Queries" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. The app isn’t loading or shows a network error.
                </div>
                <div className={style.sub_text3}>
                    Try closing and reopening the app and ensure your internet connection is stable. If the issue continues, send us a screenshot and your app version at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. I got disconnected mid-game.
                </div>
                <div className={style.sub_text3}>
                    You can rejoin the same table instantly if the game is still active. Your progress and points remain safe.                 </div>

            </div>
        </div>
    )
}

export function Wallet() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Wallet" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  What are Chips?
                </div>
                <div className={style.sub_text3}>
                    Chips are your in-game currency used to play poker games and tournaments. You can claim daily and hourly (every 60 minutes) and can also be earned by watching ads or completing tasks.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  I’ve run out of Chips. What should I do?
                </div>
                <div className={style.sub_text3}>
                    You can claim daily and hourly (every 60 minutes). You can also earn more by watching ads or completing task rewards.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  What are Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Reward Points are earned through gameplay - by ranking on leaderboards, finishing in paid tournament positions, or completing tasks. They can be redeemed at the Baazi Store for offers and gift cards from top brands.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   How do I earn Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Play games, climb leaderboards, complete daily tasks, or finish in tournament payout positions to earn Reward Points.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  How can I use Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Open the Baazi Store in the app, choose your desired offer or voucher, and redeem using your available Reward Points.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Can Reward Points be redeemed for cash?
                </div>
                <div className={style.sub_text3}>
                    No. Reward Points can only be used to redeem offers or vouchers in the Baazi Store.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. I redeemed my Reward Points but didn’t receive the item.
                </div>
                <div className={style.sub_text3}>
                    Please allow up to 48 hours for processing. If not received, contact us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> with your shortlisted reward name and redemption date for assistance.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Can I transfer Chips or Reward Points to another player?
                </div>
                <div className={style.sub_text3}>
                    No. Both Chips and Reward Points are non-transferable and linked only to your account.                 </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Where can I check my balances?
                </div>
                <div className={style.sub_text3}>
                    You can view your Chips and Reward Points in the Wallet section of the app at any time.                 </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  My balance hasn’t updated. What should I do?
                </div>
                <div className={style.sub_text3}>
                    Refresh the app or log out and back in. If the issue persists, reach out to us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> with your username and gameplay details.               </div>
            </div>
        </div>
    )
}


